export class InteractionModel {
  by: string;
  dateTime: Date;

  constructor(by?: string, dateTime?: Date) {
    this.by = by;
    this.dateTime = dateTime;
  }
}
